import { useState, useEffect } from 'react';
import type { ToastLevel } from '@admin-portal/host-contract';

type ToastEntry = { id: number; level: ToastLevel; msg: string };
const toasts: ToastEntry[] = [];
const listeners = new Set<() => void>();
let nextId = 1;

export function showToast(level: ToastLevel, msg: string) {
  const entry = { id: nextId++, level, msg };
  toasts.push(entry);
  listeners.forEach((l) => l());
  setTimeout(() => {
    const i = toasts.findIndex((t) => t.id === entry.id);
    if (i >= 0) toasts.splice(i, 1);
    listeners.forEach((l) => l());
  }, 4000);
}

export function ToastRoot() {
  const [, force] = useState(0);
  useEffect(() => {
    const sync = () => force((n) => n + 1);
    listeners.add(sync);
    return () => {
      listeners.delete(sync);
    };
  }, []);
  return (
    <div className="toasts">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.level}`}>
          {t.msg}
        </div>
      ))}
    </div>
  );
}
